module.exports = __webpack_public_path__ + "static/media/cu.cc4e731c.svg";